import { useMemo } from 'react'
import { useViewer } from './use-viewer'

/**
 * Hook to get the current selected organization from the viewer.
 * Returns the organization ID and full organization object.
 * 
 * @returns Object with `id` (string) and `organization` (OrganizationType | null)
 * @throws If viewer is not available (handled by useViewer)
 */
export const useCurrentOrganization = () => {
  const { viewer } = useViewer()
  
  return useMemo(() => {
    const organization = viewer.currentOrganization
    
    return {
      id: organization?.id ?? null,
      organization: organization ?? null,
    }
  }, [viewer.currentOrganization])
}

